import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=26a4260e&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=26a4260e&prod&lang=less&scoped=true"
import style1 from "./Register.vue?vue&type=style&index=1&id=26a4260e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a4260e",
  null
  
)

export default component.exports